import { isNavigationFailure, NavigationFailureType } from 'vue-router';

interface IRouteAuthMeta {
  adminOnly?: boolean;
  requiresAuth?: boolean;
}

/**
 * Where the global guard sends a visit to a route with this `meta`, or null to let it through.
 * Logged-in non-admins go Home: /login_redirect would only ask them to log in again.
 */
export const authRedirect = (
  meta: IRouteAuthMeta,
  { loggedIn, admin }: { loggedIn: boolean; admin: boolean },
): string | null => {
  if (!meta.requiresAuth) return null;
  if (!loggedIn) return '/login_redirect';
  if (meta.adminOnly && !admin) return '/';
  return null;
};

/** A guard redirect, or a push to the page already shown: router.push rejects, but nothing went wrong. */
export const isRedirect = (err: unknown): boolean =>
  Boolean(
    isNavigationFailure(err, NavigationFailureType.redirected) ||
      isNavigationFailure(err, NavigationFailureType.duplicated),
  );

/** For router.push(...).catch(ignoreRedirect): swallow redirects, rethrow real errors. */
export const ignoreRedirect = (err: unknown): void => {
  if (!isRedirect(err)) throw err;
};
